import axios from 'axios'
import { Config, setErrorLog } from './api/axiosCreate'

// 로그인
function login (UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'login', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 활성 유저
function isActiveUser(UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'isActiveUser', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function getInfosystemUsersAdmin(UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'getInfosystemUsersAdmin', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function setInfoSystemUserOS(UserID, Password, OSVersion) {
  const data = {
    UserID: UserID,
    Password: Password,
    OSVersion: OSVersion
  }
  return axios.post(Config.baseUrl + 'setInfoSystemUserOS', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 생체인증 저장
function setInfoUserSimpleAuth(UserID, Password, PIN, IsUseFingerPrint) {
  const data = {
    UserID: UserID,
    Password: Password,
    PIN: PIN,
    IsUseFingerPrint: IsUseFingerPrint
  }
  return axios.post(Config.baseUrl + 'setInfoUserSimpleAuth', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// 간편 비밀번호로 로그인
function getInfoUserSimpleAuthForLogin(UserID, Password, PIN) {
  const data = {
    UserID: UserID,
    Password: Password,
    PIN: PIN
  }
  return axios.post(Config.baseUrl + 'getInfoUserSimpleAuthForLogin', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

// fcm 키 저장
function getToken(UserID, Password, Token) {
  const data = {
    UserID: UserID,
    Password: Password,
    Token: Token
  }
  return axios.post(Config.baseUrl + 'token', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

function newPush(UserID, Password) {
  const data = {
    UserID: UserID,
    Password: Password
  }
  return axios.post(Config.baseUrl + 'newPush', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .catch(err => {
      setErrorLog(UserID, Password, err)
    })
}

export {
  login,
  getToken,
  newPush,
  isActiveUser,
  setInfoUserSimpleAuth,
  getInfoUserSimpleAuthForLogin,
  setInfoSystemUserOS,
  getInfosystemUsersAdmin
}
